import type {
  DataLoadingService,
  ProjectDataState,
} from '@mobile-mapping/providers';
import {
  isModelLoading,
  isModelVisible,
  isPointCloudLoading,
  isPointCloudVisible,
  isTrajectoryLoading,
  isTrajectoryVisible,
} from '@mobile-mapping/providers';
import { UnreachableCaseError } from 'ts-essentials';

export type ProjectDataLoadItemType = 'pointCloud' | 'trajectory' | 'model';

export function isProjectDataLoadItemLoading(
  dataState: ProjectDataState,
  type: ProjectDataLoadItemType,
  itemId: string
): boolean {
  switch (type) {
    case 'pointCloud':
      return isPointCloudLoading(dataState, itemId);
    case 'trajectory':
      return isTrajectoryLoading(dataState, itemId);
    case 'model':
      return isModelLoading(dataState, itemId);
    default:
      throw new UnreachableCaseError(type);
  }
}

export function isProjectDataLoadItemVisible(
  dataState: ProjectDataState,
  type: ProjectDataLoadItemType,
  itemId: string
): boolean {
  switch (type) {
    case 'pointCloud':
      return isPointCloudVisible(dataState, itemId);
    case 'trajectory':
      return isTrajectoryVisible(dataState, itemId);
    case 'model':
      return isModelVisible(dataState, itemId);
    default:
      throw new UnreachableCaseError(type);
  }
}

export function toggleProjectDataLoadItem(
  dataLoadingService: DataLoadingService,
  dataState: ProjectDataState,
  type: ProjectDataLoadItemType,
  itemId: string
): void {
  if (
    isProjectDataLoadItemLoading(dataState, type, itemId) ||
    isProjectDataLoadItemVisible(dataState, type, itemId)
  ) {
    dataLoadingService.unload(type, itemId);
    return;
  }

  dataLoadingService.load(type, itemId);
}

export function cancelProjectDataLoadItem(
  dataLoadingService: DataLoadingService,
  dataState: ProjectDataState,
  type: ProjectDataLoadItemType,
  itemId: string
): void {
  if (isProjectDataLoadItemLoading(dataState, type, itemId)) {
    dataLoadingService.unload(type, itemId);
  }
}
